import { Reveal } from "@/components/shared/Reveal";

/** A pulled line from the organizer or the board, set big between the paragraphs – the editorial breath on the page. */
export const EventQuote = ({ quote, by }) => {
  if (!quote) return null;
  return (
    <Reveal as="figure" className="my-10 border-l-[3px] border-sol pl-6 sm:my-12 sm:pl-8" testId="event-quote">
      <blockquote className="font-display text-[clamp(22px,2.2vw,32px)] font-medium leading-[1.25] tracking-[-0.02em] text-foreground text-pretty">
        <span aria-hidden="true" className="text-sol">«</span>{quote}<span aria-hidden="true" className="text-sol">»</span>
      </blockquote>
      {by && <figcaption className="t-mono mt-4 text-muted-foreground" data-testid="event-quote-by">— {by}</figcaption>}
    </Reveal>
  );
};
